import { render, staticRenderFns } from "./ApiHtmlTable.vue?vue&type=template&id=2519a2a0&scoped=true"
import script from "./ApiHtmlTable.vue?vue&type=script&lang=ts"
export * from "./ApiHtmlTable.vue?vue&type=script&lang=ts"
import style0 from "./ApiHtmlTable.vue?vue&type=style&index=0&id=2519a2a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519a2a0",
  null
  
)

export default component.exports